import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { ProductDetails } from 'src/app/modules/marketing/products/entities/product-entity';
import { ProductsService } from 'src/app/modules/marketing/products/services/products-service/products.service';
import { Product } from '../../entities/products.class';
import { ProductImageGalleryComponent } from '../product-image-gallery/product-image-gallery.component';

const CATALOG_CODE = 'IUS';

@Component({
  selector: 'app-product-row-detail',
  templateUrl: './product-row-detail.component.html',
  styleUrls: ['./product-row-detail.component.scss'],
  standalone: false
})
export class ProductRowDetailComponent implements OnInit {
  @Input() element: Product;

  appStrings: AppLocalization;
  product: ProductDetails | null = null;
  isLoading = true;
  hasError = false;
  noImage: string;

  constructor(
    private appInfoService: AppInfoService,
    private dialog: MatDialog,
    private productsService: ProductsService
  ) { }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.noImage = this.productsService.noImage;

    this.productsService.getProductsDetails(CATALOG_CODE, this.element.productNumber)
      .subscribe({
        next: (product) => {
          this.product = product;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.hasError = true;
        }
      });
  }

  onImageError(event: Event) {
    (event.target as HTMLImageElement).src = this.noImage;
  }

  openImageGallery() {
    const config = new MatDialogConfig();
    config.data = { images: this.product?.imageList || [] };
    config.panelClass = ['ds'];
    config.width = '680px';
    this.dialog.open(ProductImageGalleryComponent, config);
  }
}
